import { get, post, put, del, upload } from '@api/request';

export async function getDropdownValues(
  { userService, appraisalService, appealsService, litigationService },
  authenticationToken,
  { fieldName, endpoint, year, service },
) {
  if (fieldName === 'dueDiligenceEvidenceDeliveryMethod') {
    let tArray = {
      results: [
        {
          codeDescription: 'Portal',
          codeName: 'P',
        },
        {
          codeDescription: 'Mail',
          codeName: 'M',
        },
        {
          codeDescription: 'Email',
          codeName: 'E',
        },
        {
          codeDescription: 'In-Person',
          codeName: 'I',
        },
      ],
    };
    return tArray;
  } else if (fieldName === 'dueDiligenceEvidenceStaff') {
    const url = `${appraisalService}/trueprodigy/user/appraisal/byattribute/Appraiser`;
    let { body } = await get(authenticationToken, url);
    let tArray = {
      results:
        body && body.results
          ? body.results.map(r => {
              return { codeName: r.email, codeDescription: r.fullName };
            })
          : [],
    };
    return tArray;
  } else if (fieldName === 'cadParty' || fieldName === 'plaintiffParty') {
    const url = `${litigationService}/litigation/party`;
    let { body } = await get(authenticationToken, url);
    let tArray = {
      results:
        body && body.results
          ? body.results.map(r => {
              return { codeName: r.partyID, codeDescription: r.name };
            })
          : [],
    };
    return tArray;
  } else if (fieldName === 'panelID') {
    const url = `${appealsService}/prodigyappeals/appealpanels`;
    let { body } = await get(authenticationToken, url);
    let tArray = {
      results:
        body && body.results
          ? body.results.map(r => {
              return { codeName: r.panelID, codeDescription: r.panelRole };
            })
          : [],
    };
    return tArray;
  } else if (fieldName === 'mktMethod') {
    const url = `${appraisalService}/appraisal/modelland/methods?type=market&year=${year}`;
    let { body } = await get(authenticationToken, url);
    let tArray = {
      results:
        body && body.results
          ? body.results.map(r => {
              return { codeName: r.code, codeDescription: r.description };
            })
          : [],
    };
    return tArray;
  } else if (fieldName === 'appealAssignedTo') {
    const url = `${userService}/trueprodigy/user/appraisal/byattribute/Appraiser`;
    let { body } = await get(authenticationToken, url);
    let tArray = {
      results:
        body && body.results
          ? body.results.map(r => {
              return { codeName: r.email, codeDescription: r.fullName };
            })
          : [],
    };
    return tArray;
  } else {
    let url = `${service || appraisalService}${endpoint}`;
    const queryPrefix = url.includes('?') ? '&' : '?';
    if (fieldName === 'docketGroup') {
      url = `${url}${queryPrefix}year=0`;
    } else {
      url = year ? `${url}${queryPrefix}year=${year}` : url;
    }
    const { body } = await get(authenticationToken, url);
    return body;
  }
}

export async function fetchMassUpdatePropertiesNotIncluded(
  { appraisalService },
  authenticationToken,
  { massUpdateID }
) {
  const url = `${appraisalService}/appraisal/property/massupdate/${massUpdateID}/propertiesnotincluded`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassUpdateErrors(
  { appraisalService },
  authenticationToken,
  { massUpdateID }
) {
  const url = `${appraisalService}/appraisal/property/massupdate/${massUpdateID}/errors`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAllMassUpdateGroups(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/property/massupdategroups`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMassUpdateGroupSingle(
  { appraisalService },
  authenticationToken,
  { massUpdateGroupID },
) {
  const data = await get(
    authenticationToken,
    `${appraisalService}/appraisal/property/massupdategroup/${massUpdateGroupID}`,
  );
  const url = `${appraisalService}/appraisal/property/massupdategroup/${massUpdateGroupID}/massupdate`;
  const data2 = await get(authenticationToken, url);
  const body = {
    results: {
      massUpdateGroupData: data.body.results,
      massUpdateActionData: data2.body ? data2.body.results : [],
    },
  };
  return body;
}

export async function deleteMassUpdateGroup(
  { appraisalService },
  authenticationToken,
  { massUpdateGroupID },
) {
  const url = `${appraisalService}/appraisal/property/massupdategroup/${massUpdateGroupID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function insertMassUpdateGroup(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/property/massupdategroups`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMassUpdateConfig(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/property/massupdateconfig`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSalesMassUpdateConfig(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/sales/massupdateconfig`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraiserTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/appraisersettings/All`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/propertytype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function performMassUpdate(
  { appraisalService },
  authenticationToken,
  { payload, massUpdateGroupID },
) {
  const url = `${appraisalService}/appraisal/property/massupdategroup/${massUpdateGroupID}/performupdate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function performValuationMassUpdate(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/property/valuations/setprimarytocost`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function performValuationByTypeMassUpdate(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/property/valuations/updatevaluetype`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function validateValuationByTypeMassUpdate(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/property/valuations/validatevaluetype`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function performPermitMassUpdate(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/buildingpermits/insertmass`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function performInspectionMassUpdate(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/propertyinspections/massaction`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massUpdateBuilderAdjustments(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/property/builderadjustment/mass`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function performPropertyEventsMassUpdate(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/property/masscreateevents`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function massInsertEvidenceUpload(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massattachpresentationfile/upload`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function performMassInsertEvidence(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massattachpresentationfile`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function performAppealMassUpdate(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/appealsupdate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function performCaseMassUpdate(
  { litigationService },
  authenticationToken,
  { payload },
) {
  const url = `${litigationService}/litigation/massupdate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchSaleMassUpdateRuns(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/sales/massupdate`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSaleMassUpdateRun(
  { appraisalService },
  authenticationToken,
  { runID },
) {
  const url = `${appraisalService}/appraisal/sales/massupdate/${runID}/details`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function performSaleMassUpdate(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/sales/massupdate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function performAppealHearingLetterMassUpdate(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/appealsupdatehearingletter`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function performAppealLetterMassGenerate(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massgenerateletters`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealLetterMassGenerateJob(
  { appealsService },
  authenticationToken,
  { massLetterID },
) {
  const url = `${appealsService}/prodigyappeals/massgenerateletter/${massLetterID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function performEvidencePacketMassGenerate(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/masspacketgeneration`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function performEvidencePacketMassPublish(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/masspublishpresentation`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function performCreateControlGroup(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/newcontrolgroup`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function performMassUpdateControlGroup(
  { appealsService },
  authenticationToken,
  { payload },
) {
  const url = `${appealsService}/prodigyappeals/massjob/updatecontrolgroup`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealMassUpdateJob(
  { appealsService },
  authenticationToken,
  { groupID },
) {
  const url = `${appealsService}/prodigyappeals/massjob/${groupID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function undoMassUpdate(
  { appraisalService },
  authenticationToken,
  { payload, massUpdateGroupID },
) {
  const url = `${appraisalService}/appraisal/property/massupdategroup/${massUpdateGroupID}/undo`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function loadMassUpdateActions(
  { appraisalService },
  authenticationToken,
  { payload, massUpdateGroupID },
) {
  const url = `${appraisalService}/appraisal/property/massupdategroup/${massUpdateGroupID}/loadupdates`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function insertMassUpdateAction(
  { appraisalService },
  authenticationToken,
  { payload, massUpdateGroupID },
) {
  const url = `${appraisalService}/appraisal/property/massupdategroup/${massUpdateGroupID}/massupdate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateMassUpdateAction(
  { appraisalService },
  authenticationToken,
  { payload, massUpdateID },
) {
  const url = `${appraisalService}/appraisal/property/massupdate/${massUpdateID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function searchMarketArea(
  { appraisalService },
  authenticationToken,
  { pageSize, page, payload },
) {
  const url = `${appraisalService}/appraisal/marketarea/search?page=${page}&pageSize=${pageSize}`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMarketAreaGeneralInfo(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/generalinfo`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateMarketAreaGeneralInfo(
  { appraisalService },
  authenticationToken,
  { marketArea, year, payload },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/generalinfo`;

  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchMarketAreaStatistics(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/statistics`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function processMarketAreaStatistics(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/statistics`;

  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchMarketAreaSubdivisions(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/abstractsubdivisions`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSalesTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Sales&name=Sales Type`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSalesSource(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Sales&name=Source`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSaleSearchParameters(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/salesparameters`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateSaleSearchParameters(
  { appraisalService },
  authenticationToken,
  { marketArea, year, payload },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/salesparameters`;

  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchSales(
  { appraisalService },
  authenticationToken,
  { marketArea, year, payload },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/sales`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchBuildingPermitSummary(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/buildingpermitsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBuilders(
  { appraisalService },
  authenticationToken,
  { marketArea },
) {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(encodeURIComponent(marketArea))}/builders`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchRechecks(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/rechecks`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchProtestCounts(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/protestcount`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTrendAnalysisSales(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url =
    `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}` +
    `/trendanalysissales`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMarketAreaPopulation(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const data = { current: null, prior: null };
  const currentUrl = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/population`;
  const priorUrl = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year -
    1}/population`;

  const { body: currentBody } = await get(authenticationToken, currentUrl);
  data.current = currentBody;

  const { body: priorBody } = await get(authenticationToken, priorUrl);
  data.prior = priorBody;

  return data;
}

export async function analyzeSales(
  { appraisalService },
  authenticationToken,
  { marketArea, year, payload },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/analyze`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function applyModifierAndRecalculate(
  { recalculationService },
  authenticationToken,
  { payload },
) {
  const url = `${recalculationService}/recalc/applymodifierlaunchjob`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function resetModifierAndRecalculate(
  { recalculationService },
  authenticationToken,
  { payload },
) {
  const url = `${recalculationService}/recalc/resetmodifierlaunchjob`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchRecalculationJobStatus(
  { recalculationService },
  authenticationToken,
  { jobID },
) {
  const url = `${recalculationService}/recalc/job/${jobID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraisers({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/user/appraisal/byattribute/Appraiser`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCodeFile(
  { appraisalService },
  authenticationToken,
  { year, type, name },
) {
  let url = `${appraisalService}/appraisal/codes?type=${type}&name=${name}`;
  url += year ? `&year=${year}` : '';
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertMarketAreaBuilder(
  { appraisalService },
  authenticationToken,
  { marketArea, payload },
) {
  const url = `${appraisalService}/appraisal/marketarea/${encodeURIComponent(encodeURIComponent(marketArea))}/builders`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteMarketAreaBuilder(
  { appraisalService },
  authenticationToken,
  { marketArea, builder },
) {
  const url = `${appraisalService}/appraisal/marketareabuilder/${encodeURIComponent(encodeURIComponent(marketArea))}/${builder}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function setSaleAsOutlier(
  { appraisalService },
  authenticationToken,
  { saleID },
) {
  const url = `${appraisalService}/appraisal/sale/${saleID}/setoutlier`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function removeSaleAsOutlier(
  { appraisalService },
  authenticationToken,
  { saleID },
) {
  const url = `${appraisalService}/appraisal/sale/${saleID}/removeoutlier`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function submitMarketAreaDetail(
  { appraisalService },
  authenticationToken,
  { marketArea, year },
) {
  const url = `${appraisalService}/appraisal/marketareadetail/${encodeURIComponent(encodeURIComponent(marketArea))}/${year}/submit`;
  const { body } = await put(authenticationToken, url);
  return body;
}
